const COMPUTER_REASONING_EFFORTS = [
    'none',
    'minimal',
    'low',
    'medium',
    'high',
    'xhigh',
    'max',
];
const isRecord = (value) => typeof value === 'object' && value !== null;
export const parseComputerReasoningEffort = (value) => COMPUTER_REASONING_EFFORTS.find((effort) => effort === value) ?? null;
export const parseDeepResearchReasoningEffort = (value) => {
    if (!isRecord(value))
        return null;
    let tier;
    switch (value.default_dr_mode) {
        case 'deep_research':
            tier = 'standard';
            break;
        case 'deep_research_advanced':
            tier = 'advanced';
            break;
        default:
            return null;
    }
    if (!isRecord(value.tier_models) || !isRecord(value.tier_efforts))
        return null;
    const model = value.tier_models[tier];
    if (typeof model !== 'string' || !model)
        return null;
    return parseComputerReasoningEffort(value.tier_efforts[tier]);
};
//# sourceMappingURL=reasoningEffort.js.map